import { cn } from '@/utils/tailwind.util';
import { BaseDropdownItemUI } from '../base/BaseDropdownItemUI';
import { Checkbox } from '../control/checkbox';
import { SelectOnDrawerLayout } from './SelectOnDrawerLayout';
import { type MultiSelectProps, type SelectOption, type SelectUIProps } from './type';
export const MultiSelectOnDrawerUI = <T extends string = string,>(props: Omit<MultiSelectProps<T>, 'onValuesChange'> & SelectUIProps & {
  onSelect: (value: T) => void;
}) => {
  const isOptionSelected = (option: SelectOption<T>, values: T[]) => {
    return values.some(v => v === option.value);
  };
  return <SelectOnDrawerLayout {...props} data-sentry-element="SelectOnDrawerLayout" data-sentry-component="MultiSelectOnDrawerUI" data-sentry-source-file="MultiSelectOnDrawerUI.tsx">
      {props.options.map(option => <BaseDropdownItemUI key={option.value} onClick={() => props.onSelect(option.value)} checked={isOptionSelected(option, props.values)} disabled={option.disabled || props.maxCount != null && props.maxCount !== 0 && props.values.length >= props.maxCount && !props.values.includes(option.value)} invalid={option.invalid || false} className={cn('h-[44px] text-body-lg-medium', props.className)}>
          <Checkbox checked={isOptionSelected(option, props.values)} />
          <div className="grow text-ellipsis">{option.label}</div>
        </BaseDropdownItemUI>)}
    </SelectOnDrawerLayout>;
};